import { getMoneyValue } from "@tosize/shapes/src/lib/utils";
import type { Finish as FinishInput } from "@tosize/shapes/src/types/finish";
import type { FinishItemPostData } from "@tosize/shapes/src/types/workpiece";
import { DIAMETERID } from "../../components/Form/Finishes/DrillHoles";

export default class Finish {
	public readonly input: FinishInput;

	constructor(input: FinishInput) {
		this.input = input;
	}

	public calculatePrice(sideLength: number, options: FinishItemPostData[]): number {
		const price = options.reduce((a, b) => a + this.getModifiedPriceByUserInputs(b.option), 0);

		switch (this.input.price_data.price_type) {
			case "price_fixed":
				return price;
			case "price_per_meter": {
				const pricePerMM = price / 1000;
				const calculatedPrice = sideLength * pricePerMM;

				if (calculatedPrice > price) {
					return calculatedPrice;
				}
				break;
			}
			case "price_tiered": {
				const amount = options.filter(({ option }) => option.startsWith(DIAMETERID)).length;

				const tierPrice = this.input.price_data.tiers
					?.filter(({ from }) => amount >= Number(from))
					.sort((a, b) => Number(b.from) - Number(a.from))
					.at(0)?.price;

				const tieredPrice = amount * (tierPrice ? getMoneyValue(tierPrice) : 0);

				return tieredPrice > 0 ? tieredPrice : price;
			}
		}

		return price;
	}

	protected getModifiedPriceByUserInputs(selectedOptionCode: string): number {
		const selectedOption = Object.values(this.input.options).find(
			(option) => option.id === selectedOptionCode,
		);

		// some finishes have a custom price defined
		if (selectedOption?.constraints.price !== undefined) {
			return getMoneyValue(selectedOption.constraints.price);
		}

		return Number(this.input.price_data.price);
	}
}
